import { Box, Grid, Typography } from '@mui/material';
import { TableRowsOutlined } from '@mui/icons-material';
import React, { ReactElement } from 'react';

export default function SmallScreenPlaceholder(
  { text = 'To view the data table, access Petcademy on a larger screen', icon }: { text?: string, icon?: ReactElement },
) {
  return (
    <Grid
      item
      xs={12}
      lg={0}
      sx={{
        display: {
          xs: 'block',
          md: 'none',
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box
          sx={{
            color: 'primary.main',
            pl: 0.5,
            pr: 2,
            lineHeight: 0,
          }}
        >
          {icon || <TableRowsOutlined />}
        </Box>
        <Typography color="primary.main" variant="body1" display="inline" component="span">
          {text}
        </Typography>
      </Box>
    </Grid>
  );
}
